"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenApp = void 0;
var TokenApp_1 = require("./TokenApp");
Object.defineProperty(exports, "TokenApp", { enumerable: true, get: function () { return TokenApp_1.TokenApp; } });
var Messenger_1 = require("common/Messenger");
window.TokenApp = TokenApp_1.TokenApp;
window.TokenMessenger = Messenger_1.Messenger;
